import Vue from 'vue'
import Router from 'vue-router'
import Exchange from './views/Exchange.vue'
import OnlyExchange from './views/OnlyExchange.vue'
import CardsList from './views/CardsList.vue'
import QRCode from './views/QrCode.vue'
import Demo from './views/Demo.vue'
import Index from './views/Index.vue'
import Help from './views/Help.vue'

Vue.use(Router)

Router.prototype.goBack = function () {
  this.isBack = true
  window.history.go(-1)
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/exchange'
    },
    {
      path: '/index',
      name: 'index',
      component: Index
    },
    {
      path: '/exchange',
      name: 'home',
      component: Exchange
    },
    {
      path: '/cardslist',
      name: 'cardslist',
      component: CardsList
    },
    {
      path: '/onlyexchange',
      name: 'OnlyExchange',
      component: OnlyExchange
    },
    {
      path: '/demo',
      name: 'demo',
      component: Demo
    },
    {
      path: '/preview',
      name: 'preview',
      component: QRCode
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/help',
      name: 'help',
      component: Help
    }
  ]
})

export default router
